module.exports = __webpack_public_path__ + "img/introduction.3c6b10c5.jpg";